// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ConnectFour_gameBody__aqnYa {
    display: grid;
    grid-template-columns: 250px 1fr 250px;
    grid-template-rows: 75vh 1fr;
    width: 100%;
    min-height: 75vh;
    max-height: 85vh;
    grid-auto-flow: column;
}

.ConnectFour_gameBodyStart__\\+K\\+19 {
    grid-template-rows: 10vh 50vh;
    grid-template-columns: 250px 1fr 2fr 1fr 250px;
}


.ConnectFour_turnInfo__hbjCW {
    grid-column: 1;
    display: flex;
    justify-content: center;
    width: 250px;
    height: 50px;
    align-self: center;
}


.ConnectFour_board__s8Emp {
    grid-column: 2;
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    height: 95%;
    aspect-ratio: 7 / 6;
    gap: 10px;
    padding: 20px;
    background: #526236;
    border-radius: 15px;
    justify-self: center;
    grid-row: 1;
}

.ConnectFour_boardStart__RKp7h {
    grid-column: 3;
    grid-row: 2;
}


.ConnectFour_gameId__N24L3 {
    position: sticky;
    top: 10px;
    width: 115px;
    height: 35px;
    left: 15px;
    background: rgba(0, 0, 0, 0.85);
    color: white;
    padding: 8px 14px;
    border-radius: 8px;
    font-size: 0.95rem;
    font-weight: 700;
    letter-spacing: 1px;
    z-index: 1000;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);
    grid-row: 1 / span 1;
}
.ConnectFour_info__uGMOH {
  padding: 50px;
}

.ConnectFour_playerlist__Ea2gU {
    left: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px 20px;
    border-radius: 13px;
    font-size: 1.1rem;
    font-weight: 600;
    background: #995b5b;
    box-shadow: 0 3px 10px rgba(0, 0, 0, 0.25);
    position: relative;
    top: -50px;
    transform: translateX(-50%);
    width: 33%;
    height: 5%;

}

.ConnectFour_turn__QLr2G {

    left: 50%;
    /* transform: translateX(-50%); */
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px 20px;
    border-radius: 13px;
    font-size: 1.1rem;
    font-weight: 600;
    background: #995b5b;
    box-shadow: 0 3px 10px rgba(0, 0, 0, 0.25);
    justify-self: center;
    width: 205px;
    text-transform: capitalize;
}


.ConnectFour_buttons__5Ih6- {
    grid-column: 3;
    grid-row: 1;
    height: 100%;
    justify-self: center;
}


.ConnectFour_start__JZ92O {


    justify-self: center;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: xx-large;
    margin-bottom: 50px;
    border-radius: 19px;
    background: rgb(34, 122, 22);
    width: 10vw;    
}

.ConnectFour_cell__wuPG1 {
    width: 100%;
    aspect-ratio: 1;
    border-radius: 50%;
    background: white;
    border: none;
    padding: 0;

    display: flex;
    justify-content: center;
    align-items: center;

    overflow: hidden;
}

.ConnectFour_piece__y2ivk {
    width: 100%;
    height: 100%;
    object-fit: contain;

}
.ConnectFour_lastPieceRed__caJOb {
        animation: ConnectFour_idlepulseRed__Kz1It 2s ease-in-out infinite alternate
}
.ConnectFour_lastPieceYellow__0qrrM {
        animation: ConnectFour_idlepulseYellow__If317 2s ease-in-out infinite alternate
}
.ConnectFour_red__ZHXKA {
  background: #39399b;
}

.ConnectFour_yellow__9m5GC {
  background: #c6b39b;
}




.ConnectFour_redStartImage__r\\+Sqs{
    width: 100%;
    height: 100%;
    object-fit: contain;
    grid-column: 2;
    grid-row: 1 / 3

}

.ConnectFour_yellowStartImage__P-GE7 {
    width: 100%;
    height: 100%;
    object-fit: contain;
    grid-column: 4;
    grid-row: 1 / 3
}

@keyframes ConnectFour_idlepulseRed__Kz1It {

    from {

        opacity: 100%
        
    }

    to {

        opacity: 75%
        
    }
}
@keyframes ConnectFour_idlepulseYellow__If317 {

    from {

        filter: brightness(1.0)
        
    }

    to {

        filter: brightness(0.6)
        
    }
}

`, "",{"version":3,"sources":["webpack://./src/css/ConnectFour.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sCAAsC;IACtC,4BAA4B;IAC5B,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,6BAA6B;IAC7B,8CAA8C;AAClD;;;AAGA;IACI,cAAc;IACd,aAAa;IACb,uBAAuB;IACvB,YAAY;IACZ,YAAY;IACZ,kBAAkB;AACtB;;;AAGA;IACI,cAAc;IACd,aAAa;IACb,qCAAqC;IACrC,WAAW;IACX,mBAAmB;IACnB,SAAS;IACT,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,oBAAoB;IACpB,WAAW;AACf;;AAEA;IACI,cAAc;IACd,WAAW;AACf;;;AAGA;IACI,gBAAgB;IAChB,SAAS;IACT,YAAY;IACZ,YAAY;IACZ,UAAU;IACV,+BAA+B;IAC/B,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;IACb,yCAAyC;IACzC,oBAAoB;AACxB;AACA;EACE,aAAa;AACf;;AAEA;IACI,SAAS;IACT,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,0CAA0C;IAC1C,kBAAkB;IAClB,UAAU;IACV,2BAA2B;IAC3B,UAAU;IACV,UAAU;;AAEd;;AAEA;;IAEI,SAAS;IACT,iCAAiC;IACjC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,0CAA0C;IAC1C,oBAAoB;IACpB,YAAY;IACZ,0BAA0B;AAC9B;;;AAGA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,oBAAoB;AACxB;;;AAGA;;;IAGI,oBAAoB;IACpB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,4BAA4B;IAC5B,WAAW;AACf;;AAEA;IACI,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,iBAAiB;IACjB,YAAY;IACZ,UAAU;;IAEV,aAAa;IACb,uBAAuB;IACvB,mBAAmB;;IAEnB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;;AAEvB;AACA;QACQ;AACR;AACA;QACQ;AACR;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;;;;AAKA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,cAAc;IACd;;AAEJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,cAAc;IACd;AACJ;;AAEA;;IAEI;;QAEI;;IAEJ;;IAEA;;QAEI;;IAEJ;AACJ;AACA;;IAEI;;QAEI;;IAEJ;;IAEA;;QAEI;;IAEJ;AACJ","sourcesContent":[".gameBody {\n    display: grid;\n    grid-template-columns: 250px 1fr 250px;\n    grid-template-rows: 75vh 1fr;\n    width: 100%;\n    min-height: 75vh;\n    max-height: 85vh;\n    grid-auto-flow: column;\n}\n\n.gameBodyStart {\n    grid-template-rows: 10vh 50vh;\n    grid-template-columns: 250px 1fr 2fr 1fr 250px;\n}\n\n\n.turnInfo {\n    grid-column: 1;\n    display: flex;\n    justify-content: center;\n    width: 250px;\n    height: 50px;\n    align-self: center;\n}\n\n\n.board {\n    grid-column: 2;\n    display: grid;\n    grid-template-columns: repeat(7, 1fr);\n    height: 95%;\n    aspect-ratio: 7 / 6;\n    gap: 10px;\n    padding: 20px;\n    background: #526236;\n    border-radius: 15px;\n    justify-self: center;\n    grid-row: 1;\n}\n\n.boardStart {\n    grid-column: 3;\n    grid-row: 2;\n}\n\n\n.gameId {\n    position: sticky;\n    top: 10px;\n    width: 115px;\n    height: 35px;\n    left: 15px;\n    background: rgba(0, 0, 0, 0.85);\n    color: white;\n    padding: 8px 14px;\n    border-radius: 8px;\n    font-size: 0.95rem;\n    font-weight: 700;\n    letter-spacing: 1px;\n    z-index: 1000;\n    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);\n    grid-row: 1 / span 1;\n}\n.info {\n  padding: 50px;\n}\n\n.playerlist {\n    left: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 10px 20px;\n    border-radius: 13px;\n    font-size: 1.1rem;\n    font-weight: 600;\n    background: #995b5b;\n    box-shadow: 0 3px 10px rgba(0, 0, 0, 0.25);\n    position: relative;\n    top: -50px;\n    transform: translateX(-50%);\n    width: 33%;\n    height: 5%;\n\n}\n\n.turn {\n\n    left: 50%;\n    /* transform: translateX(-50%); */\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 10px 20px;\n    border-radius: 13px;\n    font-size: 1.1rem;\n    font-weight: 600;\n    background: #995b5b;\n    box-shadow: 0 3px 10px rgba(0, 0, 0, 0.25);\n    justify-self: center;\n    width: 205px;\n    text-transform: capitalize;\n}\n\n\n.buttons {\n    grid-column: 3;\n    grid-row: 1;\n    height: 100%;\n    justify-self: center;\n}\n\n\n.start {\n\n\n    justify-self: center;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-size: xx-large;\n    margin-bottom: 50px;\n    border-radius: 19px;\n    background: rgb(34, 122, 22);\n    width: 10vw;    \n}\n\n.cell {\n    width: 100%;\n    aspect-ratio: 1;\n    border-radius: 50%;\n    background: white;\n    border: none;\n    padding: 0;\n\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    overflow: hidden;\n}\n\n.piece {\n    width: 100%;\n    height: 100%;\n    object-fit: contain;\n\n}\n.lastPieceRed {\n        animation: idlepulseRed 2s ease-in-out infinite alternate\n}\n.lastPieceYellow {\n        animation: idlepulseYellow 2s ease-in-out infinite alternate\n}\n.red {\n  background: #39399b;\n}\n\n.yellow {\n  background: #c6b39b;\n}\n\n\n\n\n.redStartImage{\n    width: 100%;\n    height: 100%;\n    object-fit: contain;\n    grid-column: 2;\n    grid-row: 1 / 3\n\n}\n\n.yellowStartImage {\n    width: 100%;\n    height: 100%;\n    object-fit: contain;\n    grid-column: 4;\n    grid-row: 1 / 3\n}\n\n@keyframes idlepulseRed {\n\n    from {\n\n        opacity: 100%\n        \n    }\n\n    to {\n\n        opacity: 75%\n        \n    }\n}\n@keyframes idlepulseYellow {\n\n    from {\n\n        filter: brightness(1.0)\n        \n    }\n\n    to {\n\n        filter: brightness(0.6)\n        \n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"gameBody": `ConnectFour_gameBody__aqnYa`,
	"gameBodyStart": `ConnectFour_gameBodyStart__+K+19`,
	"turnInfo": `ConnectFour_turnInfo__hbjCW`,
	"board": `ConnectFour_board__s8Emp`,
	"boardStart": `ConnectFour_boardStart__RKp7h`,
	"gameId": `ConnectFour_gameId__N24L3`,
	"info": `ConnectFour_info__uGMOH`,
	"playerlist": `ConnectFour_playerlist__Ea2gU`,
	"turn": `ConnectFour_turn__QLr2G`,
	"buttons": `ConnectFour_buttons__5Ih6-`,
	"start": `ConnectFour_start__JZ92O`,
	"cell": `ConnectFour_cell__wuPG1`,
	"piece": `ConnectFour_piece__y2ivk`,
	"lastPieceRed": `ConnectFour_lastPieceRed__caJOb`,
	"idlepulseRed": `ConnectFour_idlepulseRed__Kz1It`,
	"lastPieceYellow": `ConnectFour_lastPieceYellow__0qrrM`,
	"idlepulseYellow": `ConnectFour_idlepulseYellow__If317`,
	"red": `ConnectFour_red__ZHXKA`,
	"yellow": `ConnectFour_yellow__9m5GC`,
	"redStartImage": `ConnectFour_redStartImage__r+Sqs`,
	"yellowStartImage": `ConnectFour_yellowStartImage__P-GE7`
};
export default ___CSS_LOADER_EXPORT___;
